export class UserTaskDisplayGroupMembership {
	public index;

	constructor(obj) {
		this.index = obj.index;
	}
} 
